export const SCROLL_TO_CLASS = 'education/scrolling/transition/scrollToClass';
export const SCROLL_TO_ID = 'education/scrolling/transition/scrollToId';
export const CLEAR_SCROLL = 'education/scrolling/transition/resetScroll';

export const transitionScrolling = {
    scrollToClass: (value) => ({ type: SCROLL_TO_CLASS, value }),
    scrollToId: (value) => ({ type: SCROLL_TO_ID, value }),
};

export const resetScroll = () => ({ type: CLEAR_SCROLL });
